let mutations = {
  setMerchants(state, data){

    var categories = data
    //Club all categories together to display in ALL category
    var allCategories = {
      categoryName:'All',
      marketplaces:[],
      promotions:[]
    }
    for(var key in categories){
      var category = categories[key]
      for(var i in category.marketplaces){
        var merchant = category.marketplaces[i]
        allCategories.marketplaces.push(merchant)
      }
      for(var j in category.promotions){
        var promotion = category.promotions[i]
        allCategories.promotions.push(promotion)
      }
    }
    categories.unshift(allCategories)
    state.categories = categories
  }
}
export default mutations



// WEBPACK FOOTER //
// ./src/store/merchants/mutations.js